export default {
  pending: false,
  user: null,
  collaborateurs: []
}
